import { getCurrentDate, MONTH_IN_MS, WEEK_IN_MS, } from '@office-start/date-utility';
import { useMemo } from 'react';
import { DateFilterKey } from '../models/DateFilters';
export function useDateFilterMap(useAccessedDate) {
    return useMemo(function () {
        var filterFunctionMap = new Map([
            [
                DateFilterKey.yesterday,
                function (doc) {
                    var itemDate = useAccessedDate
                        ? doc.lastAccessedTime
                        : doc.lastActionTime;
                    var yesterday = getCurrentDate();
                    yesterday.setDate(yesterday.getDate() - 1);
                    return (itemDate &&
                        itemDate.getDate() === yesterday.getDate() &&
                        itemDate.getMonth() === yesterday.getMonth() &&
                        itemDate.getFullYear() === yesterday.getFullYear());
                },
            ],
            [
                DateFilterKey.previousweek,
                function (doc) {
                    var itemDate = useAccessedDate
                        ? doc.lastAccessedTime
                        : doc.lastActionTime;
                    var lastWeek = getCurrentDate().getTime() - WEEK_IN_MS;
                    return itemDate && itemDate.getTime() >= lastWeek;
                },
            ],
            [
                DateFilterKey.previousmonth,
                function (doc) {
                    var itemDate = useAccessedDate
                        ? doc.lastAccessedTime
                        : doc.lastActionTime;
                    var lastMonth = getCurrentDate().getTime() - MONTH_IN_MS;
                    return itemDate && itemDate.getTime() >= lastMonth;
                },
            ],
        ]);
        return filterFunctionMap;
    }, [useAccessedDate]);
}
//# sourceMappingURL=useDateFilterMap.js.map